import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { User as UserType, UserRole } from "@/lib/schema";

interface RoleChangeConfirmationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  user: UserType | null;
  newRole: UserRole | null;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const RoleChangeConfirmationModal = ({
  open,
  onOpenChange,
  user,
  newRole,
  onConfirm,
  onCancel,
  isLoading
}: RoleChangeConfirmationModalProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent 
        className="z-[100]"
        overlayClassName="z-[100]"
      >
        <AlertDialogHeader>
          <AlertDialogTitle>Change User Role</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to change {user?.firstName} {user?.lastName}'s role to {newRole?.replace('_', ' ').toUpperCase()}? This will update their permissions and access level in the system.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="secondary"
            size="sm"
            disabled={isLoading}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {isLoading ? 'Updating...' : 'Update Role'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
